import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import { Vector2 } from 'three'

import { KVMessageDef } from './index'

export function getInspectionAreaLabelClickedMessage() {
  return {
    type: 'inspectionAreaLabelClicked',
    requiredData: ['inspectionAreaId'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const targetId = json.inspectionAreaId as string
      const list = kv.inspectionAreas ?? []
      const inspectionArea = list.find((ia) => ia.id === targetId)
      if (!inspectionArea) return

      kv.setPopupMenuStartPosition(new Vector2(80, 20))

      kv.setSelectedMarkup(inspectionArea)
    },
  } as KVMessageDef
}
